import { Device, MediaContent, MediaStat, User } from "./statistics.model";

function getRandomMediaStats(num:number):MediaStat[]{
  
  let stats:MediaStat[] = []

  for ( var i=0 ; i < num ; i++){
    stats.push(
      {
        timestamp:getRandomDate(
          new Date('2020-01-01T01:57:45.271Z'),
          new Date()
        )
      }
    )
  }

  return stats
}

function getRandomDate(from: Date, to: Date) {
  const fromTime = from.getTime();
  const toTime = to.getTime();
  return new Date(fromTime + Math.random() * (toTime - fromTime));
}


export const mediaContents:MediaContent[] = [
  {
    name:'Fiche technique SR202',
    type:'pdf',
    stats:getRandomMediaStats(5)
  },
  {
    name:'www.plvbroker.fr',
    type:'webview',
    stats:getRandomMediaStats(10)
  },
  {
    name:'Fiches techniques',
    type:'Dossier',
    stats:getRandomMediaStats(8)
  },
  {
    name:'Photo 01',
    type:'Image JPG',
    stats:getRandomMediaStats(6)
  },
  {
    name:'Enquête de satifactions',
    type:'Quiz',
    stats:getRandomMediaStats(5)
  }
]

export const users:User[] = [
  {
    displayName:'Home Automation',
    role:'user',
    groups:[
      {
        displayName:"Groupe A",
        devices:[
          {
            name: "Marseille",
            sessions : 243,
            createdAt:new Date(),
            medias:mediaContents
            
          },
          {
            name: "Paris La Défense",
            sessions: 641,
            createdAt:new Date()
          },
          {
            name: "Lyon Perrache",
            sessions: 801,
            createdAt:new Date()
          },
          {
            name: "Paris Champs Elysées",
            sessions: 184,
            createdAt:new Date()
          }
        ]
      }
    ]
  }
]

export const devices:Device[] = users[0].groups[0].devices





export var langStats = [
    {
      "name": "German",
      "value": 243
    },
    {
      "name": "English",
      "value": 641
    },
    {
      "name": "French",
      "value": 801
    },
    {
      "name": "Italian",
      "value": 184
    }
  ];
  